import { Link } from 'react-router-dom';

export function AccountDisabled() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="max-w-md w-full">
        <div className="mb-8 flex justify-center">
          <Link to="/" className="flex items-center space-x-3">
            <img src="/logo.png" alt="" className="h-12 w-12" />
            <img src="/logo-text.png" alt="Statsmatic" className="h-8" />
          </Link>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm text-center">
          <div className="w-16 h-16 bg-red-100 border border-red-200 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-4">Account Disabled</h1>

          <p className="text-gray-600 mb-6">
            This account has been disabled. If you believe this is in error, please contact{' '}
            <a href="mailto:support@statsmatic.io" className="text-primary-600 hover:text-primary-500 font-medium">
              support@statsmatic.io
            </a>
          </p>

          <Link
            to="/"
            className="inline-block w-full py-3 px-4 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors text-center"
          >
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AccountDisabled;
